import { Component, OnInit } from '@angular/core';
import { ConfigurationService } from '../../services/configuration.service';
import { daysOfTheWeek } from '../../constants';
import { AppUrls } from '../../app-urls';
import { AuthService } from '../../services/auth.service';
import { ParticipantInfo } from 'src/app/generated/participant/participant-info';
import { ParticipantService } from 'src/app/supplier/services/participant.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  public serverDateTime: any;
  public colonClass: string;
  public publicUrl = 'www.rts-tender.ru';
  public participantInfoUrl = AppUrls.angularRoutes.participantInfo;
  public participantInfo: ParticipantInfo;
  public counter$!: Observable<number>;
  constructor(
    private configurationService: ConfigurationService,
    private authService: AuthService,
    private participantService: ParticipantService
  ) {}

  async ngOnInit() {
    this.configurationService.serverDateTimeBehaviorSubject.subscribe((serverDateTime) => {
      this.serverDateTime = serverDateTime;
      this.colonClass = serverDateTime && serverDateTime.seconds() % 2 === 0 ? 'even' : 'odd';
    });
    this.participantInfo = await this.participantService.getInfo();
    this.counter$ = this.participantService.getCountRejection();
  }

  public serverDateString(): string {
    if (this.serverDateTime === undefined || this.serverDateTime === null) return '';

    const day =
      this.serverDateTime.date() < 10
        ? '0' + this.serverDateTime.date().toString()
        : this.serverDateTime.date().toString();
    // к возвращаемому месяцу добавляется еденица т.к. месяцы индекситуются нулем
    const month =
      this.serverDateTime.month() + 1 < 10
        ? '0' + (this.serverDateTime.month() + 1).toString()
        : (this.serverDateTime.month() + 1).toString();
    return (
      daysOfTheWeek[this.serverDateTime.day()] +
      ' ' +
      day +
      '.' +
      month +
      '.' +
      this.serverDateTime.year() +
      ' г.'
    );
  }

  public serverHoursString(): string {
    if (this.serverDateTime === undefined || this.serverDateTime === null) return '';

    return this.serverDateTime.hour() < 10
      ? '0' + this.serverDateTime.hour().toString()
      : this.serverDateTime.hour().toString();
  }

  public serverMinutesString(): string {
    if (this.serverDateTime === undefined || this.serverDateTime === null) return '';

    return this.serverDateTime.minute() < 10
      ? '0' + this.serverDateTime.minute().toString()
      : this.serverDateTime.minute().toString();
  }

  public signOut() {
    this.authService.signOut('', this.participantInfo);
  }
}
